'use client';

import { useEffect, useRef } from 'react';
import './TopEventsWidget.css';
import styled from 'styled-components';
import Swiper from 'swiper';
import useIsMobile from '@/shared/hooks/useIsMobile';
import { useCurrentLocale, useScopedI18n } from '@locales/client';

// declare global {
//   interface Window {
//     TopEventsPlugin?: new (config: {
//       partnerId: string;
//       dataURL: string;
//       wssURL: string;
//       lang: string;
//     }) => {
//       topEvents: {
//         create: (
//           container: HTMLElement,
//           config: {
//             urlPrefix: string;
//             urlPattern: string,
//             templates: {
//               eventCardTemplateId: string;
//               outcomeTemplateId: string;
//             };
//           }
//         ) => void;
//       };
//     };
//   }
// }

export default function TopEventsWidget() {
  const containerRef = useRef<HTMLDivElement>(null);
  const local = useCurrentLocale();
  const fullUrl = window.location.href;
  const isMobile = useIsMobile();
  const t = useScopedI18n('betting');

  useEffect(() => {
    const eventCardTemplate = document.createElement('template');
    eventCardTemplate.id = 'custom-event-card';
    // {{sportName}}
    if (isMobile) {
      eventCardTemplate.innerHTML = `
          <a class="my-event-card swiper-slide" data-event-id="{{eventId}}" href="{{eventUrl}}">
            <div class="event-header">
              <div class="tournament-container">
                <img src="/images/betting/sport_icon/{{sportName}}.svg"  alt="sport icon"/>
                  <span class="tournament">{{regionName}} - {{tournamentName}}</span>
              </div>
            </div>
            <div class="participants">
              <span>{{participant1}}\nVS\n{{participant2}}</span>
            </div>
            <div class="time">{{startTime}}</div>
            <div class="outcomes">{{outcomes}}</div>
          </a>
      `;
    } else {
      eventCardTemplate.innerHTML = `
          <a class="my-event-card swiper-slide" data-event-id="{{eventId}}" href="{{eventUrl}}">
            <div class="event-header">
              <div class="tournament-container">
                <img src="/images/betting/sport_icon/{{sportName}}.svg"  alt="sport icon"/>
                <div class="tournament">{{regionName}} - {{tournamentName}}</div>-->
              </div>
              <div class="date-time-container">
              <span class="time">{{startTime}}</span>
              </div>
            </div>
            <div class="participants">
              <span>{{participant1}}\nVS\n{{participant2}}</span>
            </div>
            <div class="outcomes">{{outcomes}}</div>
          </a>
      `;
    }
    document.body.appendChild(eventCardTemplate);

    const outcomeTemplate = document.createElement('template');
    outcomeTemplate.id = 'custom-outcome';
    outcomeTemplate.innerHTML = `
        <div class="my-outcome" data-odds="{{odds}}">
          <span>{{odds}}</span>
        </div>
      `;
    document.body.appendChild(outcomeTemplate);

    // 1. Проверяем, загружен ли уже SDK
    const scriptId = 'topevents-sdk';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://static.dev.phoenixapps.org/sdk/phoenix-sdk.umd.js';
      script.async = true;
      script.onload = initializePlugin;
      document.head.appendChild(script);
    } else {
      // SDK уже загружен
      initializePlugin();
    }

    function initializePlugin() {
      if (!window.TopEventsPlugin) {
        console.log('TopEventsPlugin не загружен');
        return;
      }

      const container = containerRef.current;
      if (!container) {
        return;
      }

      const eventsPlugin = new window.TopEventsPlugin({
        partnerId: '1',
        dataURL: 'https://api.p365.tech/api',
        wssURL: 'wss://api.p365.tech/ws/connection/websocket',
        // lang: 'RU',
        lang: local,
      });

      eventsPlugin.topEvents.create(container, {
        // urlPrefix: `${fullUrl}/betting?page=sport/x/x/x`,
        // urlPrefix: `${fullUrl}/betting?page=sport/:sportService/:sportName-:sportId/:tournamentName-:tournamentId`,
        urlPattern: `${fullUrl}/betting?page=sport/:sportService/:sportName-:sportId/:tournamentName-:tournamentId/:eventName-:eventId`,
        templates: {
          eventCardTemplateId: 'custom-event-card',
          outcomeTemplateId: 'custom-outcome',
        },
      });
    }

    const container = containerRef.current;
    if (!container) {
      return;
    }

    const initSwiper = () => {
      if (isMobile) {
        return;
      }

      const listEvents = container.querySelector('.top-events');
      if (!listEvents) return;

      listEvents.classList.add('swiper-wrapper');

      container.classList.add('swiper');

      const swiper = new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        grabCursor: true,
      });
      swiper.update();
    };

    const checkIfEventsExist = () => {
      const items = container.querySelectorAll('.top-events');
      if (items.length > 0) {
        initSwiper();
        return true; // "уже готово"
      }
      return false;
    };

    if (checkIfEventsExist()) {
      return;
    }

    // 👀 Наблюдаем за изменениями в container
    const observer = new MutationObserver(() => {
      if (checkIfEventsExist()) {
        observer.disconnect();
      }
    });

    // Начинаем наблюдать
    observer.observe(container, {
      childList: true,   // следим за добавлением/удалением узлов
      subtree: true,     // во всех вложенных элементах
    });


    return () => {
      eventCardTemplate.remove();
      outcomeTemplate.remove();
      observer?.disconnect();
    };
  }, [isMobile]);

  return (
      <TopContainer
        ref={containerRef}
        id="app" // можно убрать, если не нужно
      >
      </TopContainer>
  );
}

const TopContainer = styled.div`
    width: 1132px;
    margin-top: 32px;

    min-height: 200px;
    overflow: hidden;
    display: flex;
    position: relative;
    white-space: nowrap;

    flex-direction: row;
    gap: 10px;
    
    @media (max-width: 768px) {
        //margin: 32px 18px 0 18px;
        overflow: auto;
        width: 100%;
    }
`;
